export default __webpack_public_path__ + "static/media/ico_user.d80c27bc.svg";